import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MovimientoTrasladoDetalleModal } from "./MovimientoTrasladoDetalleModal";
import { MovimientoTrasladoScreen } from "./MovimientoTrasladoScreen";
import { MovimientoTrasladoTable } from "./MovimientoTrasladoTable";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { MovimientoTrasladoSearchForm } from "./MovimientoTrasladoSearchForm";
import { movimientosTrasladoStartLoading } from "../../../actions/inventario";
import { NewBtn } from "../../ui";
import { nowDateFormatBackEnd } from "../../../helpers/utils";

const MovimientoTrasladoListScreen = ({ onOpenForm }) => {
  const { comprobantesMovimientoTraslado, loading } = useSelector(
    (state) => state.inventario,
  );
  return (
    <PageHeaderUi
      title="Movimientos Traslados"
      subTitle="Listado"
      extra={[<NewBtn key="nuevo" onClick={onOpenForm} />]}
    >
      <div style={{ overflow: "hidden" }}>
        <Row>
          <Col sm={24} md={24} xl={24}>
            <MovimientoTrasladoSearchForm />
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <MovimientoTrasladoTable
              movimientos={comprobantesMovimientoTraslado}
              loading={loading}
            />
          </Col>
        </Row>
      </div>
      <MovimientoTrasladoDetalleModal />
    </PageHeaderUi>
  );
};

export const MovimientoTrasladoList = () => {
  const [openForm, setOpenForm] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const nowDate = nowDateFormatBackEnd();
    dispatch(
      movimientosTrasladoStartLoading({
        fechaemision: `${nowDate}|${nowDate}`,
      }),
    );
  }, []);
  const handleOpenForm = () => setOpenForm(true);
  const handleCloseForm = () => setOpenForm(false);
  if (openForm)
    return <MovimientoTrasladoScreen onCloseForm={handleCloseForm} />;
  else return <MovimientoTrasladoListScreen onOpenForm={handleOpenForm} />;
};

export default MovimientoTrasladoList;
